export const ModalWIP = {
  title: 'Hey there!',
  content:
    "Noodled is very much a work in progress at the moment; it's buggy, doesn't look great and certainly doesn't function all that well. To be honest, you shouldn't really be here right now.",
  btnText: 'Whatever',
};



// WEBPACK FOOTER //
// ./src/API/content.js